module.exports = __webpack_public_path__ + "static/media/disappointed1.50d98e7e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/disappointed1.gif
// module id = 863
// module chunks = 0